import React, { useEffect } from 'react';
import { HashRouter as Router, Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { App as CapacitorApp } from '@capacitor/app';
import Login from './core/Login';
import EventOverview from './features/events/EventOverview';
import EventCreate from './features/events/EventCreate';
import EventDetailed from './features/events/EventDetailed';
import EventCheckin from './features/events/EventCheckin';
import CampaignOverview from './features/campaigns/CampaignOverview';
import CampaignDetailed from './features/campaigns/CampaignDetailed';
import AppShell from './AppShell';

function BackHandler() {
    const location = useLocation();
    const navigate = useNavigate();
    useEffect(() => {
        const remove = CapacitorApp.addListener('backButton', ({ canGoBack }) => {
            if (location.pathname !== '/' && window.history.length > 1) {
                navigate(-1);
            } else {
                // Stay in app: navigate to events if logged in, otherwise login
                if (window.location.hash && window.location.hash !== '#/') {
                    navigate('/');
                }
            }
        });
        return () => { remove && remove.remove && remove.remove(); };
    }, [location, navigate]);
    return null;
}

function AppAndroid() {
    return (
        <Router>
            <BackHandler />
            <Routes>
                <Route path="/" element={<Login />} />
                <Route path="/events" element={<AppShell active="events"><EventOverview /></AppShell>} />
                <Route path="/events/create" element={<AppShell active="events"><EventCreate /></AppShell>} />
                <Route path="/events/edit/:id" element={<AppShell active="events"><EventCreate /></AppShell>} />
                <Route path="/events/:id" element={<AppShell active="events"><EventDetailed /></AppShell>} />
                <Route path="/events/checkin/:id" element={<AppShell active="events"><EventCheckin /></AppShell>} />
                <Route path="/campaigns" element={<AppShell active="campaigns"><CampaignOverview /></AppShell>} />
                <Route path="/campaigns/:id" element={<AppShell active="campaigns"><CampaignDetailed /></AppShell>} />
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </Router>
    );
}

export default AppAndroid;


